// extracted by mini-css-extract-plugin
export default {"leftSidePanel":"LeftSidePanel_leftSidePanel__2Szpv"};